import {generateRouteTo} from 'epic-fortnite-react';
import {localizedMessage} from 'epic-fortnite-react/components/message/Message';
import * as PropTypes from 'prop-types';
import React from 'react';
import {Link, withRouter} from 'react-router-dom';

import Background from '../../common/Background';
import CommonCTABtn from '../../common/CommonCTABtn';
import VideoPlayButton from '../../common/VideoPlayButton';

import CarouselSlideFooter from './CarouselSlideFooter';
import {Slide} from './Types';

interface Props {
  slide: Slide;
  mobile: boolean;
  tablet: boolean;
  isAndroid: boolean;
  showVideo: (videId: string) => void;
}

class Carousel extends React.PureComponent<Props> {
  static propTypes = {
    slide: PropTypes.object,
    mobile: PropTypes.bool,
    tablet: PropTypes.bool,
    isAndroid: PropTypes.bool,
    showVideo: PropTypes.func,
  };

  render() {
    const {slide, mobile, tablet, showVideo, isAndroid, location} = this.props;
    const {
      background,
      captionPos = 'center',
      captionTitle,
      captionDesc,
      captionImage,
      button,
      videoId,
      watchLabel,
      textColor,
      type = '',
      androidDownload,
      secondaryTextColor,
      captionDesc2,
      captionDesc3,
      desc2Color,
      desc3Color,
      footerImage,
      footerText,
      footerAlignment,
      seasonBug,
    } = slide;
    const style = textColor ? {color: textColor} : {};
    const styleSecond = secondaryTextColor ? {color: secondaryTextColor} : {};
    const styleDesc2 = desc2Color ? {color: desc2Color} : {};
    const styleDesc3 = desc3Color ? {color: desc3Color} : {};
    const showAndroidDownloadBtn = isAndroid && androidDownload;
    return (
      <div className={`slide ${type}`}>
        <Background mobile={mobile} tablet={tablet} background={background} />
        {seasonBug && <img alt="Season Bug" className="season-bug" src={seasonBug} />}

        <div className={`caption ${captionPos}`}>
          {captionImage && <img src={captionImage} alt="badge" />}
          {captionTitle && <h3 style={style}>{captionTitle}</h3>}
          {captionDesc && (
            <h1 className="desktop top" style={styleSecond}>
              {captionDesc}
            </h1>
          )}
          {captionDesc2 && (
            <h1 className="desktop captionDesc2" style={styleDesc2}>
              {captionDesc2}
            </h1>
          )}
          {captionDesc && (
            <h1 className="mobile top" style={styleSecond}>
              {captionDesc} {captionDesc2}
            </h1>
          )}
          {captionDesc3 && <h3 style={styleDesc3}>{captionDesc3}</h3>}
          {showAndroidDownloadBtn ? (
            <Link
              to={generateRouteTo('/mobile/android', location)}
              className="btn btn-primary btn-hover-transform">
              {localizedMessage('epic.fortnite.battleRoyale.playFreeNow')}
            </Link>
          ) : (
            <CommonCTABtn ctaConfig={button} className="btn-hover-transform" />
          )}
        </div>
        {(footerImage || footerText) && (
          <CarouselSlideFooter image={footerImage} text={footerText} alignment={footerAlignment} />
        )}
        {videoId && (
          <div className="play-wrapper">
            <h3>{watchLabel}</h3>
            <VideoPlayButton onClick={() => showVideo(videoId)} className="bp-videoplay" />
          </div>
        )}
      </div>
    );
  }
}

export default withRouter(Carousel);
